"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPill = AccountPill;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles_1 = require("../styles");
const useStyles = (0, styles_1.createUseThemeStyles)((theme) => ({
    pill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "0.4rem",
        padding: "0.2rem 0.6rem",
        borderRadius: "999px",
        background: theme.palette.surface,
        border: `1px solid color-mix(in oklab, ${theme.palette.light.neutral} 12%, transparent)`,
        color: theme.palette.light.neutral,
        fontFamily: theme.typography.primary,
        fontSize: "1rem",
        lineHeight: 1,
        maxWidth: "100%",
        minWidth: 0,
    },
    button: {
        "cursor": "pointer",
        "&:hover": {
            borderColor: `color-mix(in oklab, ${theme.palette.light.neutral} 28%, transparent)`,
        },
    },
    leading: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
    },
    avatar: {
        "width": "1.4rem",
        "height": "1.4rem",
        "borderRadius": "50%",
        "objectFit": "cover",
        "& img": {
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            objectFit: "cover",
            display: "block",
        },
    },
    name: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    separator: {
        color: theme.palette.muted,
    },
    rank: {
        whiteSpace: "nowrap",
        color: theme.palette.success.light,
    },
}));
function AccountPill({ name, avatar, icon, rank, rankColor, onClick, className, }) {
    const classes = useStyles();
    const interactive = !!onClick;
    const content = (React.createElement(React.Fragment, null,
        (avatar || icon) && (React.createElement("span", { className: (0, classnames_1.default)(classes.leading, { [classes.avatar]: !!avatar }) }, avatar !== null && avatar !== void 0 ? avatar : icon)),
        React.createElement("span", { className: classes.name }, name),
        rank && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: classes.separator }, "\u00B7"),
            React.createElement("span", { className: classes.rank, style: rankColor ? { color: rankColor } : undefined }, rank)))));
    if (interactive) {
        return (React.createElement("button", { type: "button", className: (0, classnames_1.default)(classes.pill, classes.button, className), onClick: onClick }, content));
    }
    return React.createElement("span", { className: (0, classnames_1.default)(classes.pill, className) }, content);
}
